import { render } from "./OrderCard.vue?vue&type=template&id=606ff14a"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__